import ImagePhaseShifter from './image_phase_shifter'
import { ImageExifUtil } from './image_exif_util'

export default class ImageConverter {
  // Base64へ変換する
  public static async toBase64(
    img: HTMLImageElement | File | HTMLCanvasElement,
    ext?: string
  ): Promise<string> {
    return ImagePhaseShifter.toBase64url(img, ext)
  }

  public static base64url2base64(img_url: string) {
    return img_url
      .replace('data:image/png;base64,', '')
      .replace('data:image/jpg;base64,', '')
      .replace('data:image/jpeg;base64,', '')
  }

  public static async toImage(
    src: HTMLCanvasElement | string | File | any
  ): Promise<HTMLImageElement> {
    return ImagePhaseShifter.toImage(src)
  }

  public static async toImageData(src: HTMLCanvasElement) {
    if (src instanceof HTMLCanvasElement) {
      const ctx = src.getContext('2d')!
      const inImageData = ctx.getImageData(0, 0, src.width, src.height)
      return inImageData
    } else {
      throw `not implement class`
    }
  }

  // Canvasへ変換する
  public static async toCanvas(
    img: HTMLImageElement | File | HTMLCanvasElement | string | ImageData
  ) {
    return ImagePhaseShifter.toCanvas(img)
  }

  // ファイルからbase64
  public static async file2base64url(file: File): Promise<string> {
    return ImagePhaseShifter.toBase64url(file)
  }

  // fileからImageData
  public static async file2imageData(file: File): Promise<ImageData> {
    const fr = new FileReader()
    const promise = new Promise<ImageData>((resolve, reject) => {
      fr.onload = (evt: any) => {
        const base64url = evt.target!.result
        this.url2imageDate(base64url).then((imageData) => {
          resolve(imageData)
        })
      }
    })
    fr.readAsDataURL(file)
    return promise
  }

  // urlからcanvas作成
  public static async url2canvas(url: string): Promise<HTMLCanvasElement> {
    return ImagePhaseShifter.toCanvas(url)
  }

  // urlからImageData
  public static async url2imageDate(url: string): Promise<ImageData> {
    const canvas = await this.url2canvas(url)
    const image_data = await this.toImageData(canvas)
    this.dispose_canvas(canvas)
    return image_data
  }

  // urlからImageData
  public static async url2img(url: string): Promise<HTMLImageElement> {
    const url_img = new Image()
    const promise = new Promise<HTMLImageElement>((resolve, reject) => {
      url_img.onload = () => resolve(url_img)
    })
    url_img.src = url as string
    return await promise
  }

  // Imageをcanvasへ切り出す
  public static crop_image2canvas(
    img: HTMLImageElement,
    rim: { l: number; t: number; w: number; h: number }
  ): HTMLCanvasElement {
    const canvas = document.createElement('canvas')
    canvas.width = rim.w
    canvas.height = rim.h
    const l = 0 <= rim.l ? 0 : -rim.l
    const t = 0 <= rim.t ? 0 : -rim.t
    const ctx = canvas.getContext('2d')!
    ctx.drawImage(
      img,
      rim.l + l,
      rim.t + t,
      rim.w - l,
      rim.h - t,
      l,
      t,
      rim.w - l,
      rim.h - t
    )
    return canvas
  }

  public static async canvas2gray(
    c: HTMLCanvasElement
  ): Promise<HTMLCanvasElement> {
    const ctx = c.getContext('2d')!
    const idataSrc = ctx.getImageData(0, 0, c.width, c.height) // original
    const idataTrg = ctx.createImageData(c.width, c.height) // empty data
    const dataSrc = idataSrc.data // reference the data itself
    const dataTrg = idataTrg.data
    const len = dataSrc.length
    let i = 0
    let luma

    // convert by iterating over each pixel each representing RGBA
    for (; i < len; i += 4) {
      // calculate luma, here using Rec 709
      luma =
        dataSrc[i] * 0.2126 + dataSrc[i + 1] * 0.7152 + dataSrc[i + 2] * 0.0722

      // update target's RGB using the same luma value for all channels
      dataTrg[i] = dataTrg[i + 1] = dataTrg[i + 2] = luma
      dataTrg[i + 3] = dataSrc[i + 3] // copy alpha
    }

    // // put back luma data so we can save it as image
    // ctx.putImageData(idataTrg, 0, 0);
    // demo.src = c.toDataURL();                                 // set demo result's src url

    // // restore backup data
    // ctx.putImageData(idataSrc, 0, 0);
    return this.toCanvas(idataTrg)
  }

  // canvas を解放する
  public static dispose_canvas(canvas: HTMLCanvasElement) {
    if (canvas) {
      canvas.width = 0
      canvas.height = 0
    }
  }

  // 画像をbase64へconvert
  static async complessImageFileTo64(
    file: File,
    size: { w: number; h: number }
  ): Promise<string> {
    const srcCanvas = await ImageExifUtil.getRotatedImageByExif(file)

    // サイズ比較
    const srcSize = srcCanvas.width * srcCanvas.height
    const correctSize = size.w * size.h

    // const size_limit = console.log(`complessImageFileTo64 ${correctSize * 1.5} < ${srcSize} `);
    let resultCanvas = srcCanvas
    if (correctSize * 1.5 < srcSize) {
      const rate = Math.sqrt(srcSize / (correctSize * 1.5))

      const canvas = document.createElement('canvas')
      canvas.width = Math.round(srcCanvas.width / rate)
      canvas.height = Math.round(srcCanvas.height / rate)
      console.log(`new size ${canvas.width} * ${canvas.height}`)

      const ctx = canvas.getContext('2d')!
      ctx.drawImage(
        srcCanvas,
        0,
        0,
        srcCanvas.width,
        srcCanvas.height,
        0,
        0,
        canvas.width,
        canvas.height
      )
      resultCanvas = canvas
    }

    const result64 = resultCanvas.toDataURL('image/jpeg', 0.85)
    console.log(`after size`, result64.length)
    this.dispose_canvas(srcCanvas)
    this.dispose_canvas(resultCanvas)
    return ImageConverter.base64url2base64(result64)
  }
}
